import React, { Fragment, useState } from 'react';
import { Popconfirm } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import Helpers from '@Apis/helpers';
import H3Text from '../../../../../uilib/h3Text';

function ViewIncomingPaymentHeader({
  selectedPaymentOutgoing,
  user,
  isQuickView,
  paymentType,
  callback,
  updatePaymentsOutgoingStatus,
  updatePaymentsOutgoingStatusLoading,
}) {
  const [currentUpdate, setCurrentUpdate] = useState('');
  return (
    <Fragment>
      <div className="view-document__title">
        <div className="view-document__title-number-wrapper">
          <H3Text text={`#${selectedPaymentOutgoing?.payment_id}`} className="view-document__title-number" />
          <div className="view-document__title-status" style={{ backgroundColor: Helpers.getStatusColor(selectedPaymentOutgoing?.approval_status).color }}>
            {selectedPaymentOutgoing?.approval_status?.replaceAll('_', ' ')}
          </div>
        </div>
        {paymentType === 'PAYMENT' && !isQuickView && !selectedPaymentOutgoing?.zoho_account_id && !selectedPaymentOutgoing?.tally_bill_payment_number && !selectedPaymentOutgoing?.shopify_transaction_id &&
          Helpers.getPermission(Helpers.permissionEntities.CUSTOMER_PAYMENTS, Helpers.permissionTypes.UPDATE, user) &&
          (
            <div className="view-document__title-actions">
              <div className="action-buttons">
                <Popconfirm
                  placement="topRight"
                  title="Are you sure you want to delete this payment permanently?"
                  onConfirm={() => {
                    setCurrentUpdate('DELETE');
                    updatePaymentsOutgoingStatus({
                      payment_id: selectedPaymentOutgoing?.payment_id,
                      tenant_id: selectedPaymentOutgoing?.tenant_id,
                      status: (selectedPaymentOutgoing?.linked_invoices?.length || selectedPaymentOutgoing?.payment_type === 'INCOMING') ? 'DELETED' : 'CANCELLED',
                    }, () => {
                      setCurrentUpdate('');
                      callback();
                    });
                  }}
                  okText="Yes"
                  cancelText="No"
                >
                  <H3Text
                    text={(
                      <Fragment>
                        {(currentUpdate === 'DELETE' && updatePaymentsOutgoingStatusLoading)
                          ? (
                            <div style={{ marginTop: '-5px' }}>
                              <LoadingOutlined />
                            </div>
                          ) : (
                            <Fragment>
                              {' '}
                              {(selectedPaymentOutgoing?.linked_invoices?.length || selectedPaymentOutgoing?.payment_type === 'INCOMING') ? 'Delete' : 'Cancel'}
                            </Fragment>
                          )}
                      </Fragment>
                    )}
                    className="action-button action-button-big action-button-payment"
                  />
                </Popconfirm>
              </div>
            </div>
          )}
      </div>
    </Fragment>
  );
}

export default ViewIncomingPaymentHeader;
